import { render, staticRenderFns } from "./img-retina.vue?vue&type=template&id=524de422&scoped=true"
import script from "./img-retina.vue?vue&type=script&lang=ts"
export * from "./img-retina.vue?vue&type=script&lang=ts"
import style0 from "./img-retina.vue?vue&type=style&index=0&id=524de422&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524de422",
  null
  
)

export default component.exports